import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import DefaultCarosel from '../../common-components/default-carousel'
import NumbersCard from './NumbersCard'
import {DefaultComponentWrapper} from '../common'
import HeadlineWithDescription from '../headline-with-description'
import {StyledPicture, RelativeWrapper} from './styles'
import Spacer from '../spacer'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      numberLabel: PropTypes.string.isRequired,
      description: PropTypes.string,
      image: PropTypes.string,
    }).isRequired
  ),
  textColorHexCode: PropTypes.string,
  isTextSm: PropTypes.bool,
  isImgLg: PropTypes.bool,
  isContentVerticallyCentered: PropTypes.bool,
  backgroundImage: PropTypes.string,
  headline: PropTypes.string,
  isSmHeadlineOnLgOrLower: PropTypes.bool,
  description: PropTypes.string,
  headlineAlign: PropTypes.oneOf(['left', 'right', 'center']),
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  cards: [],
  textColorHexCode: undefined,
  isTextSm: false,
  isImgLg: false,
  isContentVerticallyCentered: false,
  backgroundImage: undefined,
  headline: undefined,
  isSmHeadlineOnLgOrLower: false,
  description: undefined,
  headlineAlign: 'center',
  backgroundColor: undefined,
}

export type NumbersCarouselProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const NumbersCarousel: React.FC<NumbersCarouselProps> = ({
  cards,
  textColorHexCode,
  isTextSm,
  isImgLg,
  isContentVerticallyCentered,
  backgroundImage,
  headline,
  isSmHeadlineOnLgOrLower,
  description,
  headlineAlign,
  backgroundColor,
}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <RelativeWrapper hasBackgroundImage={!!backgroundImage}>
      {backgroundImage && (
        <StyledPicture
          alt="numbers-carousel-background-image"
          src={backgroundImage}
          objectFit="cover"
          isBackgroundImage
          objectPosition="100% 100%"
        />
      )}
      <HeadlineWithDescription
        headline={headline}
        isSmHeadlineOnLgOrLower={isSmHeadlineOnLgOrLower}
        description={description}
        textAlign={headlineAlign}
      />
      {headline && <Spacer heightInPixel="64" />}
      <DefaultCarosel>
        {cards?.map((props, i) => (
          <NumbersCard
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            cardDetails={props}
            isTextSm={isTextSm}
            isImgLg={isImgLg}
            isCentered={isContentVerticallyCentered}
            colorHex={textColorHexCode}
          />
        )) ?? []}
      </DefaultCarosel>
    </RelativeWrapper>
  </DefaultComponentWrapper>
)

NumbersCarousel.propTypes = propTypes

NumbersCarousel.defaultProps = defaultProps

export default NumbersCarousel
